export const getYoutubeIdentifier = (url?: string | null) => {
  if (url?.includes("youtu.be")) {
    const parsedUrlArray = url.split("/");
    return parsedUrlArray[parsedUrlArray.length - 1];
  } else if (url?.includes("https://www.youtube.com/watch?")) {
    const parsedUrlArray = url.split("=")[1].split("&");
    return parsedUrlArray[0];
  } else if (url?.includes("www.youtube.com/embed")) {
    const parsedUrlArray = url.split("?")[0].split("/");
    return parsedUrlArray[parsedUrlArray.length - 1];
  }
};
